import React, { useEffect } from "react";
import services from "../../assets/json/services.json";
import classes from "./Services.module.css";
import { Service } from "../../Components/index";
import { Link } from "react-router-dom";
import { useInView } from "react-intersection-observer";
import { useSpring, animated } from "react-spring";

function Services({ limitedServices = 4, showBtn = true }) {
  let maxServices = services.length;
  let displayServicesList = maxServices - limitedServices;

  const [props, api] = useSpring(() => ({
    from: { translateY: 0 },
    to: { translateY: 50 },
    config: { daily: 500, duration: 1000 },
  }));

  const [ref, inView] = useInView();

  useEffect(() => {
    if (inView) {
      api.start({
        from: { translateY: -50 },
        to: { translateY: 0 },
      });
    }
  }, [inView, api]);

  let serviceList = services
    .map((service) => {
      return (
        <Service
          key={service.id}
          title={service.title}
          text={service.text}
          src={service.icon}
          alt={service.title}
        />
      );
    })
    .splice(0, displayServicesList);

  return (
    <section className={classes.Services}>
      <animated.h2 className={classes.ServicesTitle} style={props} ref={ref}>
        Our <span>Services</span>
      </animated.h2>
      <ul className={classes.ServicesList}>{serviceList}</ul>
      {showBtn ? (
        <Link className={classes.ServicesLink} to="/services">
          More
        </Link>
      ) : null}
    </section>
  );
}

export default Services;
